<template>
  <div class="workerorderindex">
    <div class="content" v-show="contentis" v-for="(item,index1) in showdata" :key="index1">
       <div v-if="item.typeId==12">
          <span class="label">{{item.name+':'}}</span>
          <el-select class="wid" v-model="gamevalue[item.id]" @visible-change="changedata(item,gamearea[item.id])"   @change="datacommit(gamevalue[item.id],item)">
          <el-option
            v-for="item in gamearea[item.id]"
            :key="item.label"
            :label="item.label"
            :value="item.value"
            >
          </el-option>
        </el-select>
       </div>
      <div class="dns" v-else-if="item.typeId==1">
         <span class="label">{{item.name+':'}}</span>
         <el-input class="wid"  v-model="dns[item.id]"  :placeholder="item.defaultContent"   @blur="datacommit(dns[item.id],item)"></el-input>
       </div>
        <div class="dns" v-else-if="item.typeId==5">
         <span class="label">{{item.name+':'}}</span>
         <el-input class="wid"  v-model="phonenumver[item.id]" :placeholder="item.defaultContent"   @blur="datacommit(phonenumver[item.id],item)"></el-input>
       </div>
       <div class="dns" v-else-if="item.typeId==6">
         <span class="label">{{item.name+':'}}</span>
         <el-input class="wid"  v-model="number[item.id]"  :placeholder="item.defaultContent"  @blur="datacommit(number[item.id],item, $event)"></el-input>
       </div>
       <div class="dns" v-else-if="item.typeId==7">
         <span class="label">{{item.name+':'}}</span>
         <el-input class="wid"  v-model="idcard[item.id]" :placeholder="item.defaultContent"  @blur="datacommit(idcard[item.id],item)"></el-input>
       </div>
       <div class="dns" v-else-if="item.typeId==8">
         <span class="label">{{item.name+':'}}</span>
         <el-input class="wid"  v-model="email[item.id]"  :placeholder="item.defaultContent"  @blur="datacommit(email[item.id],item)"></el-input>
       </div>
         <div class="explain" v-else-if="item.typeId==2">
          <span class="label">{{item.name+':'}}</span>
         <el-input
            class="wid"
            type="textarea"
            :rows="4"
            v-model="explain[item.id]"
            :placeholder="item.defaultContent"
            @blur="datacommit(explain[item.id],item)">
          </el-input>
       </div>
      <div class="sex" v-else-if="item.typeId==13">
         <span class="label">{{item.name+':'}}</span>
         <el-radio-group class="radio" v-model="sex[item.id]" @change="datacommit(sex[item.id],item)">
           <el-radio v-for="(ele,index2) in sexlabel[item.id]"   :label="ele.value" :key="index2">{{ele.value}}</el-radio>
        </el-radio-group>

       </div>
        <!--<div class="hobbys">
         <span class="label">兴趣爱好:</span>
         <span :class=" {'hobby':true, 'back':item.is}" v-for="(item,index) in hobbys" @click="heightlight(index)" > {{item.value}}</span>
         <p>多选，您可以选择1-5个选项</p>
       </div>-->
       <div class="picture" v-else-if="item.typeId==9">
         <span class="label">{{item.name+':'}}</span>
         <p class="pictureclass" style="width:250px;float: left;line-height: 23px;">为了帮助您更好的解决问题,请上传相关描述的图片。每张不超过9M，支持jpg、png、bmp、gif</p>
           <el-upload
            class="upload-demo wid"
            :action="action"
            :on-success="handlePreview"
            :on-remove="handleRemove"
            :before-upload="beforeload"
            :file-list="fileList2[item.name]"
            list-type="picture"
            :withCredentials=true>
            <el-button   @click="datacommit(fileList2[item.name],item)" :id="item.spanid+'a'"  v-if="picid[item.id]==true"  size="small" type="primary" class="color" style="margin-top:80px;margin-left:-430px" :style="{backgroundColor:boxBodyColor}"> 添加文件 </el-button>
          </el-upload>
       </div>
       <div class="city" v-else-if="item.typeId==14">
          <span class="label">{{item.name+':'}}</span>
           <el-checkbox-group
            v-model="checkedCities1[item.id]"
            class="cityclass"
            @change="datacommit(checkedCities1[item.id],item)"
            >
            <el-checkbox v-for="city in cities[item.id]" :label="city" :key="city">{{city}}</el-checkbox>
          </el-checkbox-group>
       </div>
       <div class="picture" v-else-if="item.typeId==15">
         <span class="label">{{item.name+':'}}</span>
         <p class="pictureclass" style="width:250px;float: left;line-height: 23px;">为了帮助您更好的解决问题,请上传相关描述的视频。视频大小不超过500M</p>
           <el-upload
            class="upload-demo wid"
            :action="action"
            :on-success="handleVideoPreview"
            :on-remove="handleVideoRemove"
            :before-upload="videoBeforeload"
            :file-list="fileVideoList[item.name]"
            list-type="picture"
            accept="video/*"
            :withCredentials=true>
            <el-button @click="datacommit(fileVideoList[item.name], item)" :id="item.spanid+'a'" v-if="picid[item.id]==true" size="small" type="primary" class="color"  style="margin-top:80px;margin-left:-430px" :style="{backgroundColor:boxBodyColor}"> 添加文件 </el-button>
          </el-upload>
       </div>
       <div class="date" v-else-if="item.typeId==16">
          <span class="label">{{item.name+':'}}</span>
          <div class="block">
            <el-date-picker
              v-model="datetimes[item.id]"
              type="datetime"
              class="time"
              :placeholder="item.defaultContent || '选择日期时间'"
              @change="datacommit(datetimes[item.id],item)">
            </el-date-picker>
          </div>
       </div>
       <div class="date" v-else-if="item.typeId==3">
          <span class="label">{{item.name+':'}}</span>
          <div class="block">
            <el-date-picker
              v-model="datetime[item.id]"
              type="date"
              :picker-options="pickerOptions0"
              class="time"
              :placeholder="item.defaultContent"
              @change="datacommit(datetime[item.id],item)">
            </el-date-picker>
          </div>
       </div>
       <div class="date" v-else-if="item.typeId==4">
          <span class="label">{{item.name+':'}}</span>
          <div class="block">
            <el-time-picker
              v-model="hourtime[item.id]"
              type="date"
              class="time"
              format="HH:mm"
              :placeholder="item.defaultContent"
              @change="datacommit(hourtime[item.id],item, $event)">
            </el-time-picker>
          </div>
       </div>
      <span class="error1" v-if="(item.required==true && (item.typeId ==12 || item.typeId ==13 || item.typeId ==14) && item.defaultContent == '') || (item.required==true && !(item.typeId ==12 || item.typeId ==13 || item.typeId ==14))" :id="item.spanid">*必填项</span>
      <span class="error1" v-else :id="item.spanid"></span>
       <p style="clear:both"></p>
    </div>
    <div class="btn" v-if="contentis==true && btnclass==1">
      <el-button class="color" type="primary" @click="commit" :loading="commitLoading" :style="{backgroundColor:boxBodyColor}">提交</el-button>
    </div>
    <div class="btn" v-else-if="contentis==true && btnclass==2">
      <el-button class="color" type="primary" style="background:#ccc">提交</el-button>
    </div>
    <div class="download" v-show="downloadis">
      <img src="../../assets/workorder/download.png">
      <p>正在提交...</p>
    </div>
    <div class="success" v-show="successis">
      <img src="../../assets/workorder/success.png">
      <h4>提交成功,感谢您的反馈！</h4>
    </div>

    <div class="success" v-show="erroris">
      <img src="../../assets/workorder/error.png">
      <h4 class="error">问题反馈失败,请稍后再试！</h4>
      <p>{{jishi+'秒之后重试'}}</p>
    </div>

    <div class="login" v-show="loginis">
        <p>手机号为查看单据处理结果的依据</p>
        <div>
          <span>手机号</span>
          <el-input v-model="phone" class="phonenumber" placeholder="请输入手机号码" @blur="phonego"></el-input>
          <p >{{phoneis}}</p>
        </div>
        <div class="mat">
          <span>随机码</span>
          <el-input v-model="verify" class="verify" placeholder="短信随机码"></el-input>
          <span v-if="verifyis" class="verifybtn" @click="verifygo" :style="{backgroundColor:boxBodyColor}">获取随机码</span>
          <span v-else class="verifybtn" :style="{backgroundColor:boxBodyColor}">{{timesecond+"s"}}</span>.
           <p>{{veris}}</p>
        </div>
        <el-button class="color verbtn" type="primary" @click="verifyconfirm" :style="{backgroundColor:boxBodyColor}"style="margin-left:140px;">下一步</el-button>
    </div>

  </div>

</template>

<script>
import * as Urls from '../url.js'
import axios from '@/utils/request.js'
import * as Constants from '../../common/Constants'
export default {
  name: 'workcommit',
  data () {
    return {
      paixu:[],
      boxBodyColor:'',
      logoUrl:'',
      companyName:'',
      displayMode:'',
      btnclass:2,
      btnis:false,
      urlbridge:"",
      videobridge:"",
      fileVideoList:{},
      datetimes:{},
      jishi:5,
      kefuis:false,
      action:'',
      phone:"",
      phoneis:"",
      veris:'',
      verify:"",
      verifyis:true,
      timesecond:60,
      basurl:Urls.baseurl,
      md5:"",
      href:"",
      showdata:[],
      erroris:false,
      successis:false,
      downloadis:false,
      loginis:false,
      contentis:false,
      pickerOptions0: {
          // disabledDate(time) {
          //   return time.getTime() < Date.now() - 8.64e7;
          // }
      },
      commitis:false,
      commitLoading: false,
      datetime:{},
      hourtime:{},
      phonenumver:{},
      number:{},
      idcard:{},
      email:{},
      fileList2:{},
      allquestion:[],
      questionclass:[],
      gamearea:{},
      gamevalue:{},
      dns:{},
      explain:{},
      sex:{},
      sexlabel:{},
      hobbys:[{value:"运动",is:false},{value:"宅",is:false},{value:"电影",is:false},{value:"美食",is:false},{value:"DIY",is:false}],
      checkedCities1: {},
      cities:{},
      parmas:[],
      submittable:{},
      picid:{}
    }
  },
  props: ['workOrderId', 'msgId'],
  mounted(){
    var vm =this;
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor')
      vm.companyName = sessionStorage.getItem('companyName')

      vm.logoUrl = sessionStorage.getItem('logoUrl')
      vm.displayMode = sessionStorage.getItem('displayMode')
    this.questionclass=[];
    this.questionclass.push(sessionStorage.getItem("navname"));
    this.questionclass.push("单据提交");
    this.md5=sessionStorage.getItem("md5");
    //this.href= window.location.href.split("?")[1];
    this.href= this.workOrderId;
    if(this.href=="butianinfor"){
      this.butianinfor()
    }else{
      this.showis();
    }

    //判断客服是否显示
     axios.get(this.basurl+'/api/visitor/product/conf/showOnlineService?visitorMd5Code='+this.md5).then(function(response){
        if(response.data.code==1){
          vm.kefuis=true;
        }
     })
  },
  methods:{
     //判断跳转页面
    kefugo(){
        axios.get(this.basurl+'/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code='+this.md5).then(function(response){

          if(response.data.code==1){
            var obj=response.data.data;

            if(obj.imStatus==" waiting"){

              window.location.href="#/imLineUp";

            }else if(obj.imStatus=="chatting"){

               window.location.href="#/imSession";
            }else{
                if(obj.target==1){
                  window.location.href="#/spirit";
                }
                if(obj.target==2){
                  window.location.href="#/imDirectory";
                }
            }
          }
        })
    },
    //加入判断是否已经添加
    datacommitis(name,value,id){
      var vm=this;
      var is=true;
        this.parmas.forEach( function(item, index) {
            if(item.id==name){
              item.value=value;
              is=false;
              //vm.commitis=true;
              vm.submittable[id]=true;
              document.getElementById(id).innerHTML=" ";
            }
        });
        //console.log(this.parmas)
      return is;
    },
    //改变级联的值
    changedata(item,id){
        var vm=this;
        if(item.parentId!=null && item.parentId!="" && item.parentId!=undefined && item.parentId!=" "){
          //vm.$set( vm.gamearea,obj.id,arr);
          //vm.$set( vm.gamevalue,obj.id,obj.defaultContent);
          console.log(vm.gamevalue[item.parentId]);
          if(vm.gamevalue[item.parentId]!=""){
              axios.get(this.basurl+'/api/visitor/wo/dataDicList/'+item.id+'?visitorMd5Code='+this.md5+"&parentId="+vm.gamevalue[item.parentId]).then(function(response){
                  if(response.data.code==1){
                      console.log(response)
                      // console.log(vm.gamearea[obj.id])
                      // console.log(vm.gamearea)
                       var arrdata=response.data.data;
                       //console.log(arrdata)
                       var arr=[];
                      arrdata.forEach( function(element, index) {
                        var obj={};
                        obj.value=element.id;
                        obj.label=element.content;
                        arr.push(obj)
                      });
                      //console.log(arr)
                      vm.gamearea[item.id]=[];
                      vm.$set( vm.gamearea,item.id,arr);
                      vm.$set( vm.gamevalue,item.id,vm.gamevalue[item.id]);
                      // console.log(vm.gamearea);
                      // console.log(vm.gamevalue)

                  }

            })
          }

      }
    },
    //清空父节点
    clearparnt(item){
      var vm=this;
      //console.log(item.id);
      this.showdata.forEach( function(element, index) {
         if(element.parentId==item.id){
          //console.log(element);
          var arr=[];
            //vm.gamearea[element.id]=arr;
            vm.$set( vm.gamearea,element.id,arr);
            vm.$set( vm.gamevalue,element.id,"");
            //console.log(vm.gamearea)
         }
      });
    },
    //收集这个值
    datacommit(value, item){
      //console.log(e.target,"e.target")
      var typeid=item.typeId;
      //console.log(item.maxLength)
      var length=item.maxLength;
      var require=item.required;
      var name=item.name
      var spanid=item.spanid
      if(typeid==3){
        var now=new Date(value);
        var year = now.getFullYear();
        var month =(now.getMonth() + 1).toString();
        var day = (now.getDate()).toString();
        if (month.length == 1) {
            month = "0" + month;
        }
        if (day.length == 1) {
            day = "0" + day;
        }
        value = year + "-"+month +"-"+ day;
        //console.log(value)
      }
      if(typeid==16) {
        const now=new Date(value);
        let year = now.getFullYear();
        let month =(now.getMonth() + 1).toString();
        let day = (now.getDate()).toString();
        let hours = now.getHours();
        let minutes = now.getMinutes();
        if (month.length == 1) {
            month = "0" + month;
        }
        if (day.length == 1) {
            day = "0" + day;
        }
        if (hours.length == 1) {
            hours = "0" + hours;
        }
        if (minutes.length == 1) {
            minutes = "0" + minutes;
        }
        value = year + "-"+month +"-"+ day + " "+hours+":"+minutes;
      }
      if(typeid==4){
        var now=new Date(value);
        var hour = now.getHours();
        var minute =now.getMinutes();
        if (hour < 10) {
            hour = "0" + hour;
        }
        if (minute< 10) {
            minute = "0" + minute;
        }
        value = hour + ":"+minute ;
        //console.log(value)
      }
      //console.log(value+"/"+typeid);
      var valueis=false;
      var obj={};
      //单选和多选框
      if(typeid==1 || typeid==2){
        //console.log(value.replace(/(^s*)|(s*$)/g, ""))
        if(value.length>length || value==undefined || value=='' || value.match(/^[ ]+$/) ){
          valueis=false;
        }else{
           valueis=true;
        }
        console.log(value)
        if(require==false && (value==undefined || value=='' ||  value==' '  || value.match(/^[ ]+$/))){
          valueis=true;
        }
        if(valueis==false){
           var  message= '请输入长度为1~'+length+'字符';
            document.getElementById(spanid).innerHTML=message;
            this.submittable[spanid]=false;

        }else{
          var is=this.datacommitis(item.id,value,spanid)
          if(is){
             obj.name=name;
             obj.value=value;
             obj.id=item.id;
             this.parmas.push(obj);
          }
          this.submittable[spanid]=true;
         document.getElementById(spanid).innerHTML="";
        }

      }
      //日期框
      if(typeid==3){

          if(value=="NaN-NaN-NaN"){
            valueis=false;
          }else{
            valueis=true;
          }
          if(require==false && value=="NaN-NaN-NaN"){
            valueis=true;
          }


          if(valueis==false){
            document.getElementById(spanid).innerHTML="*必填项";
            this.submittable[spanid]=false;
            valueis=false;
          }else{
            var is=this.datacommitis(item.id,value,spanid)
            if(is){
               obj.name=name;
               obj.value=value;
               obj.id=item.id;
               this.parmas.push(obj);
               this.submittable[spanid]=true;
               document.getElementById(spanid).innerHTML="";
             }
             valueis=true;
          }

      }
      //时间框判断
      if(typeid==4){

          if(value=="NaN:NaN"){
            valueis=false;
          }else{
            valueis=true;
          }
          if(require==false && value=="NaN:NaN"){
            valueis=true;
          }

        if(valueis==false){
           document.getElementById(spanid).innerHTML="*必填项";
            this.submittable[spanid]=false;
        }else{
          var is=this.datacommitis(item.id,value,spanid)
          if(is){
             obj.name=name;
             obj.value=value;
             obj.id=item.id;
             this.parmas.push(obj)
             this.submittable[spanid]=true;
             document.getElementById(spanid).innerHTML="";
          }
        }
      }
      if(typeid==16){
        if(value=="NaN-NaN-NaN NaN:NaN") {
            valueis=false;
          }else{
            valueis=true;
          }
          if(require==false && value=="NaN-NaN-NaN NaN:NaN"){
            valueis=true;
          }


          if(valueis==false){
            document.getElementById(spanid).innerHTML="*必填项";
            this.submittable[spanid]=false;
            valueis=false;
          }else{
            var is=this.datacommitis(item.id,value,spanid)
            console.log(value, is, '=========222==========')
            if(is) {
              obj.name=name;
              obj.value=value;
              obj.id=item.id;
              this.parmas.push(obj);
              this.submittable[spanid]=true;
              document.getElementById(spanid).innerHTML="";
            }
            //  valueis=true;
          }
      }
      // 手机号验证
      if(typeid==5){
        var phoneis=/^1\d{10}$/.test(value)
          if(phoneis==false){
            valueis=false;
          }else{
            valueis=true;
          }
          console.log(value)
          if(require==false && (value==undefined || value=='')){
            valueis=true;
          }
          if(valueis==false){
             document.getElementById(spanid).innerHTML="请输入正确的手机号";
              this.submittable[spanid]=false;
          }else{
             var is=this.datacommitis(item.id,value,spanid)
             if(is){
                obj.name=name;
                obj.value=value;
                obj.id=item.id;
                this.parmas.push(obj)
                this.submittable[spanid]=true;
               document.getElementById(spanid).innerHTML="";
              }
          }
      }
      // 数字文本框
      if(typeid==6){
        //alert("jinlai")
        console.log(document.getElementById(spanid).innerHTML,"innerHtml")
        var numberis=/^\d+$/.test(value);
        if(numberis==false){
            valueis=false;
          }else{
            if(value.length>length){
              valueis=false;
            }else{
              valueis=true;
            }

          }

          if(require==false && (value==undefined || value=='')){
            valueis=true;
          }
           if(valueis==false){
             document.getElementById(spanid).innerHTML="请输入长度为1~"+length+"的数字";
              this.submittable[spanid]=false;
          }else{
             var is=this.datacommitis(item.id,value,spanid)
              if(is){
               obj.name=name;
               obj.value=value;
               obj.id=item.id;
               this.parmas.push(obj);
                this.submittable[spanid]=true;
               document.getElementById(spanid).innerHTML="";
                //alert("更细吧 ！！")
                console.log(document.getElementById(spanid),"123123123")
              }
          }

      }
      // 身份证文本框

      if(typeid==7){
        var idcardis=/^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/.test(value);
        if(idcardis==false){
          valueis=false;
        }else{
          valueis=true;
        }
        if(require==false && (value==undefined || value=='')){
          valueis=true;
        }
         if(valueis==false){
             document.getElementById(spanid).innerHTML="请输入正确的身份证号";
              this.submittable[spanid]=false;
          }else{
            var is=this.datacommitis(item.id,value,spanid)
             if(is){
               obj.name=name;
               obj.value=value;
               obj.id=item.id;
               this.parmas.push(obj);
               this.submittable[spanid]=true;
               document.getElementById(spanid).innerHTML="";
             }
          }



      }

      //邮箱地址
      if(typeid==8){
        var emlis=/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(value);
        if(emlis==false ){

          valueis=false;
        }else{
          if(value!=undefined){
            if( value.length>length){
              valueis=false;
            }else{
               valueis=true;
            }
          }
        }
        console.log(value)
        if(require==false && (value==undefined || value=='')){
          valueis=true;
        }
        if(length!=null){
          var text="请输入"+length+"位以内正确的邮箱地址"
        }else{
          var text="请输入正确的邮箱地址"
        }

         if(valueis==false){
             document.getElementById(spanid).innerHTML=text;
              this.submittable[spanid]=false;
          }else{
                var is=this.datacommitis(item.id,value,spanid)
              if(is){
                 obj.name=name;
                 obj.value=value;
                 obj.id=item.id;
                 this.parmas.push(obj);
                 this.submittable[spanid]=true;
               document.getElementById(spanid).innerHTML="";
              }
          }




      }
      //文件上传
      if(typeid==9){
        this.urlbridge=item;
        //obj[name]=value;
        //this.parmas.push(obj)
      }
      // 上传视频
      if (typeid==15) {
        console.log(item, '9999999999999999')
        this.videobridge = item;
      }
      //下拉框
      if(typeid==12){
        var vname="";
        this.gamearea[item.id].forEach( function(element, index) {
          if(element.value==value){
            vname=element.label
            value=vname;
          }
        });
        //console.log(value)
        if(value!=undefined && value!=''){
           valueis=true;
        }else{
          valueis=false;
        }

        if(require==false){
          valueis=true;
        }

        if(valueis==false){
             document.getElementById(spanid).innerHTML="*必填项";
              this.submittable[spanid]=false;
          }else{
              this.clearparnt(item)
                var is=this.datacommitis(item.id,value,spanid)
              if(is){
                 obj.name=name;
                 obj.value=value;
                 obj.id=item.id;
                 this.parmas.push(obj);
                 this.submittable[spanid]=true;
               document.getElementById(spanid).innerHTML="";
              }
          }



      }
      //单选框
      if(typeid==13){
          //console.log(value,"hhhhh")
          if(value!=undefined && value!=''){
            valueis=true;
          }else{
            valueis=false;
          }
          if(require==false && value==""){
          valueis=true;
        }
       if(valueis==false){
         document.getElementById(spanid).innerHTML="*必填项";
              this.submittable[spanid]=false;
        }else{
          var is=this.datacommitis(item.id,value,spanid)
          if(is){
             obj.name=name;
             obj.value=value;
             obj.id=item.id;
            this.parmas.push(obj);
            this.submittable[spanid]=true;
           document.getElementById(spanid).innerHTML="";
          }
       }

      }
      //多选框
      if(typeid==14){
        //console.log(value)
        if(value.length>0){
          valueis=true;
        }else{
          valueis=false;
        }
        if(require==false){
          valueis=true;
        }
        if(valueis==false){
             document.getElementById(spanid).innerHTML="*必填项";
              this.submittable[spanid]=false;
          }else{
                var is=this.datacommitis(item.id,value,spanid)
              if(is){
                 obj.name=name;
                 obj.value=value;
                 obj.id=item.id;
                 this.parmas.push(obj);
                 this.submittable[spanid]=true;
               document.getElementById(spanid).innerHTML="";
              }
          }

      }

      var comit=true;
      var dataobj=this.submittable;
      //console.log(dataobj)
      for(var key in dataobj){

         if(dataobj[key]==false){
          comit=false;
         }
      }
      if(comit==true){
        this.btnclass=1;
      }
      // if(valueis==false){

      //   this.commitis=false;
      // }else{
      //   this.commitis=true;
      // }
      //console.log(this.commitis)
    },
    heightlight(index) {
      var is=this.hobbys[index].is;
      if(is){
        this.hobbys[index].is=false;
      }else{
        this.hobbys[index].is=true;
      }
    },
    videoBeforeload(file) {
       console.log(file);
       var typeis=false;

       // var arr=file.name.split(".");
        var type=file.type
      //console.log(type)
      if(/^video\/.*$/.test(type)){
        typeis=true;
      }
      if(typeis==false){
         this.$message.error('文件格式不正确');
        return false
      }
      if(file.size / 1024 > (1024 * 500)){
        this.$message.error('文件大于500M');
        return false
      }
    },
    beforeload(file) {
      console.log(file);
      var typeis=false;

      // var arr=file.name.split(".");
        var type=file.type
      //console.log(type)
      if(/(gif|jpg|jpeg|bmp|png)$/.test(type)){
        typeis=true;
      }
      if(typeis==false){
         this.$message.error('文件格式不正确');
        return false
      }
      if(file.size / 1024 > (1024 * 9)){
        this.$message.error('文件大于9M');
        return false
      }
    },
    handleRemove() {
      var vm=this;
      //alert(1)
      //console.log(this.urlbridge)
      // if(this.urlbridge==""){
      //   this.urlbridge=obj;
      // }
       vm.$set( vm.picid,this.urlbridge.id,true);
       //console.log( this.picid)
      //document.getElementById(this.urlbridge.spanid+"a").style.display ="block";
      if(this.urlbridge.required==true){
        document.getElementById(this.urlbridge.spanid).innerHTML="*必填项";
        this.submittable[this.urlbridge.spanid]=false;
      }
      this.urlbridge=" ";
    },
    handleVideoRemove() {
      var vm=this;
       vm.$set( vm.picid,this.videobridge.id,true);
       //console.log( this.picid)
      //document.getElementById(this.videobridge.spanid+"a").style.display ="block";
      if(this.videobridge.required==true){
        document.getElementById(this.videobridge.spanid).innerHTML="*必填项";
        this.submittable[this.videobridge.spanid]=false;
      }
      this.videobridge=" ";
    },
    handlePreview(response, file, fileList) {
        console.log(this.picid[this.urlbridge.id])
      console.log(response)
     if(response.code==1){
      var vm=this;
       //document.getElementById(this.urlbridge.spanid+"a").style.display ="none";
        vm.$set( vm.picid,this.urlbridge.id,false);
       //this.picid[this.urlbridge.id]=false;
       console.log( this.picid)
       document.getElementById(this.urlbridge.spanid).innerHTML=" ";
       var is=this.datacommitis(this.urlbridge.id,response.data,this.urlbridge.spanid);
       if(is){
          this.submittable[this.urlbridge.spanid]=true;
           var obj={};
           obj.name=this.urlbridge.name;
            obj.id=this.urlbridge.id;
           obj.value=response.data;
           this.parmas.push(obj);
            var comit=true;
          var dataobj=this.submittable;
          console.log(dataobj)
          for(var key in dataobj){

             if(dataobj[key]==false){
              comit=false;
             }
          }
          if(comit==true){
            this.btnclass=1;
          }
       }

     }

    },
    handleVideoPreview(response, file, fileList) {
        console.log( this.picid[this.videobridge.id])
      console.log(response)
     if(response.code==1){
      var vm=this;
       //document.getElementById(this.videobridge.spanid+"a").style.display ="none";
        vm.$set( vm.picid,this.videobridge.id,false);
       //this.picid[this.videobridge.id]=false;
       console.log( this.picid)
       document.getElementById(this.videobridge.spanid).innerHTML=" ";
       var is=this.datacommitis(this.videobridge.id,response.data,this.videobridge.spanid);
       if(is){
          this.submittable[this.videobridge.spanid]=true;
           var obj={};
           obj.name=this.videobridge.name;
            obj.id=this.videobridge.id;
           obj.value=response.data;
           this.parmas.push(obj);
            let comit=true;
          const dataobj=this.submittable;
          console.log(dataobj)
          for(let key in dataobj){

             if(dataobj[key]==false){
              comit=false;
             }
          }
          if(comit==true){
            this.btnclass=1;
          }
       }

     }

    },
    commit(){
      var vm=this;
      var comit=true;
      var dataobj=this.submittable
      vm.commitLoading = true; // 设置提交按钮为 loading 状态
      console.log(this.parmas)
      for(var key in dataobj){

         if(dataobj[key]==false){
          comit=false;
         }
      }


      if(comit==true){
        var obj={};
        obj.orderId=this.href;
        var arr=[];

        this.parmas.forEach( function(element, index) {
          if(typeof(element.value)=="object"){
            var str=element.value.join(",");
            element.value=str;
          }
        });
      //排序
        var l=this.parmas.length;
        this.paixu.forEach( function(element, index) {
            var haveis=false;
            for(var i=0;i<l;i++){
              if(vm.parmas[i].id==element.id){
                var obj={};
                obj.fieldId=vm.parmas[i].id;
                obj.name=vm.parmas[i].name;
                obj.value=vm.parmas[i].value;
                haveis=true;
                arr.push(obj)
              }
            }
            if(haveis==false){
              if( element.typeId == 14) {
                var obj2={};
                obj2.fieldId=element.id;
                obj2.name=element.name;
                obj2.value=element.defaultContent;
                arr.push(obj2)
              }else {
                var obj={};
                obj.fieldId=element.id;
                obj.name=element.name;
                obj.value="";
                arr.push(obj)
              }
            }

        });

        obj.variables=arr;
       // console.log(this.parmas)
       // console.log(this.paixu)
        console.log(obj.variables)
        axios.post(this.basurl+'/api/visitor/wo/submitOrder?visitorMd5Code='+this.md5,obj).then(function(response){
          vm.commitLoading = false; // 提交后恢复提交按钮的状态
          if(response.data.code==1){
            let obj = {}
                console.log(response.data.data,"123123")
              var content = response.data.data.orderName;

            axios.post(vm.basurl+'/api/visitor/im/confirmEvent/'+vm.msgId+'?visitorMd5Code='+vm.md5,obj).then(function(response){
              if(response.data.code==1){
                vm.successis=true;
                vm.contentis=false;
                vm.$store.dispatch({
                  type:'workOrderSubmittied',
                  workOrderId: vm.workOrderId,
                  orderName: content,
                  router: vm.$router,
                  visitorMd5Code: sessionStorage.md5,
                  msgId:vm.msgId
                })
                // vm.$store.commit('addMessageContentToMessageList', {
                //             type: Constants.TEXT_TYPE,
                //             data: '您已提交了工单: ' + content,
                //             // seq: imMsgHeader.seqOrigin,
                //             // sessionId: imMsgHeader.sessionId,
                //             // msgId: imMsgHeader.msgId,
                //             // sendFrom: imMsgHeader.fromId,
                //             userNickName: vm.$store.state.im.userNickNamePool[vm.$store.state.im.currentUserId]
                // })
              }
            })

          }else if (response.data.code==401){
            console.log("401")
            vm.loginis=true;
            vm.contentis=false;
          }else if(response.data.code==400){
            vm.erroris=true;
            vm.contentis=false;
            var tme=setInterval(function () {
              vm.jishi = vm.jishi-1;
              if(vm.jishi==0){
                window.location.reload()
                clearInterval(tme)
              }
            },1000)
          }

        })
      }else{
          this.$message({
          message: '数据填写错误',
          type: 'warning'
         });
         vm.commitLoading = false; // 提交失败后恢复提交按钮的状态
       }

     // window.location.href="/#/workdetail"
    },
    //
    butianinfor(){
       var vm=this;
      var obj=JSON.parse(sessionStorage.getItem('butianinfor'));
      axios.get(this.basurl+'/api/visitor/wo/processInstanceFields/'+obj.processInstanceId+'?visitorMd5Code='+this.md5).then(function(response){
        if(response.data.code=1){
            vm.show(response.data,2)
        };
      })
      //console.log(obj)
    },
    //展示数据
    show(data,index){
      var arrda = data.data;
      var vm=this;
      arrda.forEach( function(item, index) {
        vm.paixu.push(item)
        item.spanid=vm.workOrderId+index+Number(new Date());
        if(item.typeId==9 || item.typeId==15){
          vm.$set( vm.picid,item.id,true);
          //console.log(vm.picid)
        }
        if((item.required==true && (item.typeId ==12 || item.typeId ==13 || item.typeId ==14) && item.defaultContent == '') || (item.required==true && !(item.typeId ==12 || item.typeId ==13 || item.typeId ==14))){
          vm.submittable[item.spanid]=false;
        }
        else {
          vm.submittable[item.spanid]=true;
        }
          vm.showdata.push(item);
          vm.datacollect(item);
      });
      //console.log(this.submittable)
      //console.log(arrda,"555")
      //console.log(vm.paixu)
    },
    //判断是否授权
    showis(){
    var vm = this;
      axios.get(this.basurl+'/api/visitor/wo/getFields/'+this.href+'?visitorMd5Code='+this.md5).then(function(response){
        var da=response.data
        console.log(da,"da")

        if(da.code==1){
          vm.loginis=false;
          // vm.successis = true;
          vm.contentis=true;

          vm.show(da,1)
        }else if(da.code==401){
          vm.contentis=false;
          vm.loginis=true;
        }
     })
    },
   //手机验证
    verifyconfirm(){
      //console.log( this.verify)
      var vm=this;
      vm.veris="";
      if(this.verify!="" && this.btnis==true){
         axios.post(this.basurl+'/api/visitor/wo/msgCaptchaValid?visitorMd5Code='+this.md5+"&phoneNum="+this.phone+"&code="+this.verify).then(function(response){
            if(response.data.code==1){
              // vm.showis();
              vm.veris="";
              vm.loginis = false;
              vm.commit();
            }else if(response.data.code==0){
             vm.veris="验证码已过期请重新获取"
            }else if(response.data.code==4032){
              this.$message.error('获取验证码过于频繁')
            }else{
               vm.veris="验证码填写错误"
            }
         })
      }else{
         vm.veris="请获取验证码"
      }

    },
    verifygo(){
      var vm =this;
      if(this.phone==''){
        this.phoneis="手机号不能为空"
      }
      if(this.phoneis!="手机号格式错误" &&  this.phoneis!="手机号不能为空"){
        this.btnis=true;
         axios.get(this.basurl+'/api/visitor/wo/msgCaptcha?visitorMd5Code='+this.md5+"&phoneNum="+this.phone).then(function(response){
          //console.log(response)
            if(response.data.code==1){
                 vm.verifyis=false;
                 var timer = setInterval(function () {
                    vm.timesecond= vm.timesecond-1;
                    if( vm.timesecond==0){
                      clearInterval(timer);
                      vm.verifyis=true;
                      vm.timesecond=60;
                    }
                 },1000)
            }else if(response.data.code==4032){
               vm.$message.error('验证码获取过于频繁');
            }else if(response.data.code==4504){
              vm.$message.error('验证码已过期请重新获取');
            }
         })

      }
    },
    phonego(){
      var phonenumis=/^1\d{10}$/.test(this.phone);
      //console.log(phonenumis)
      if(phonenumis==false){
        this.phoneis="手机号格式错误"
      }else{
        this.phoneis="";
      }
    },
    // 设置相关的数据值，并且有值的时候更新一下提示语
    setMapData(data, key, value, dataObj){
      this.$set(data, key, value);
      if (value !=null && value != undefined && value != '') {
        setTimeout(()=>{
          this.datacommit(value, dataObj)
        },0)
      }
    },
    datacollect(obj){
      var vm=this;
      if(obj.parentId==null){
          obj.parentId=" ";
        }
      if(obj.typeId==12){
        axios.get(this.basurl+'/api/visitor/wo/dataDicList/'+obj.id+'?visitorMd5Code='+this.md5+"&parentId="+obj.parentId).then(function(response){
            if(response.data.code==1){

                // console.log(vm.gamearea[obj.id])
                // console.log(vm.gamearea)
                 var arrdata=response.data.data;
                 var arr=[];
                 //console.log(arrdata)
                arrdata.forEach( function(element, index) {
                  var obj={};
                  obj.value=element.id;
                  obj.label=element.content;
                  arr.push(obj)
                });
                //console.log(arr)
                vm.$set( vm.gamearea,obj.id,arr);
                // vm.$set( vm.gamevalue,obj.id,obj.defaultContent);
                vm.setMapData(vm.gamevalue,obj.id,obj.enteredValue || obj.defaultContent,obj)
                //console.log(vm.gamearea);
                //console.log(vm.gamevalue)

            }else{
              console.log('拉取数据失败')
            }
        })
      }else if(obj.typeId==1){
            axios.get(this.basurl+'/api/visitor/wo/dataDicList/'+obj.id+'?visitorMd5Code='+this.md5+"&parentId="+obj.parentId).then(function(response){
                if(response.data.code==1){

                    //  var arrdata=response.data.data;
                    //  console.log(arrdata)
                    //  var arr=[];
                    // arrdata.forEach( function(element, index) {
                    //   var obj={};
                    //   arr.push(obj)
                    // });
                    //console.log(arr)
                    //console.log(vm.gamevalue)
                    //vm.$set( vm.dns,obj.id,obj.defaultContent);
                    vm.setMapData(vm.dns,obj.id,obj.enteredValue || obj.defaultContent,obj)
                }else{
                  console.log('拉取数据失败')
                }
          })
      }else if(obj.typeId==2){
          //vm.$set( vm.explain,obj.id,obj.defaultContent);
          vm.setMapData(vm.explain,obj.id,obj.enteredValue || obj.defaultContent,obj)

      }else if(obj.typeId==3){ // 日期
        console.log(obj.enteredValue, obj.defaultContent, '=========999========')
        //vm.$set( vm.datetime,obj.id,obj.defaultContent);
        let timeVal = ''
        if (/^\d{4}-\d{1,2}-\d{1,2}/.test(obj.enteredValue || obj.defaultContent)) {
          timeVal = (obj.enteredValue || obj.defaultContent)
        }
        vm.setMapData(vm.datetime,obj.id, timeVal,obj)
      }else if (obj.typeId==4) {
        //console.log(obj.defaultContent+":00")
        //vm.$set( vm.hourtime,obj.id,"");
      }else if (obj.typeId==5) {

        //vm.$set( vm.phonenumver,obj.id,obj.defaultContent);
        vm.setMapData(vm.phonenumver,obj.id,obj.enteredValue || obj.defaultContent,obj)
      }else if (obj.typeId==6) {
        vm.setMapData(vm.number,obj.id,obj.enteredValue || obj.defaultContent,obj)
        //vm.$set( vm.number,obj.id,obj.defaultContent);
      }else if (obj.typeId==7) {
        vm.setMapData(vm.idcard,obj.id,obj.enteredValue || obj.defaultContent,obj)
       // vm.$set( vm.idcard,obj.id,obj.defaultContent);
      }else if (obj.typeId==8) {
        vm.setMapData(vm.email,obj.id,obj.enteredValue || obj.defaultContent,obj)
       // vm.$set( vm.email,obj.id,obj.defaultContent);
      }else if(obj.typeId==14){
            axios.get(this.basurl+'/api/visitor/wo/dataDicList/'+obj.id+'?visitorMd5Code='+this.md5+"&parentId="+obj.parentId).then(function(response){
                if(response.data.code==1){

                    var arrdata=response.data.data;
                    //返回数据有问题
                     console.log(obj.defaultContent);


                     if(obj.defaultContent.split(",").length>1){
                       var arrd=obj.defaultContent.split(",")
                     }else{
                      var arrd=[];
                      arrd.push(obj.defaultContent.split(",")[0])
                     }

                     var arr=[];
                     var arr1=[];
                     var defaultContentid=true;
                     var l=arrdata.length;
                     arrd.forEach( function(element, index) {

                        var addis = false;
                        for(var i=0;i<l;i++){
                          if(arrdata[i].content==element){
                            addis=true;
                          }
                        }
                        if(addis==false){
                          defaultContentid=false;
                        }
                          arr1.push(element);

                      });
                     if(defaultContentid==false){
                        arr1=[];
                     }
                      arrdata.forEach( function(element, index) {
                        arr.push(element.content);
                      });
                      vm.$set( vm. checkedCities1,obj.id,arr1);
                      vm.$set( vm. cities,obj.id,arr);
                }else{
                  console.log('拉取数据失败')
                }
          })
      }else if (obj.typeId==13) {

          axios.get(this.basurl+'/api/visitor/wo/dataDicList/'+obj.id+'?visitorMd5Code='+this.md5+"&parentId="+obj.parentId).then(function(response){
                if(response.data.code==1){

                    var arrdata=response.data.data;
                    //console.log(arrdata);
                    var arr=[];
                    var defaultContentid=false;
                    console.log(obj.defaultContent,8989)
                    arrdata.forEach( function(element, index) {
                      var obj1={};
                      obj1.value=element.content;
                      obj1.label=element.content;
                      arr.push(obj1);
                      //console.log(element.content)
                      if(obj.defaultContent==element.content){
                        defaultContentid=true;
                      }
                    });
                    //console.log(arr)
                    if(defaultContentid==false){
                      obj.defaultContent="";
                    }
                    console.log(obj.defaultContent,39)
                     vm.$set( vm.sexlabel,obj.id,arr);
                     vm.$set( vm.sex,obj.id,obj.defaultContent);
                }else{
                  console.log('拉取数据失败')
                }
          })
      }
      else if (obj.typeId==9 || obj.typeId==15) {
        var arr=[];
        this.action=this.basurl+'/api/visitor/wo/fileUpload?visitorMd5Code='+this.md5;
        // var arro={};
        //  arro.url=obj.defaultContent;
        // if(arro.url !=""){
        //    this.picid[obj.id]=false;
        // }else{
        //   this.picid[obj.id]=true;
        // }
        // arro.name='file.jpg';

        // if(arro.url!=""){
        //   arr.push(arro)
        // }
        if (obj.typeId==9) {
          vm.$set(vm.fileList2, obj.name, arr);
        } else {
          vm.$set(vm.fileVideoList, obj.name, arr);
        }
        // vm.$set( vm.fileList2,obj.name,arr);
        //console.log(vm.fileList2)
      } else if(obj.typeId==16){ // 日期+时间
        //vm.$set( vm.datetime,obj.id,obj.defaultContent);
        // console.log(obj.enteredValue || obj.defaultContent, '=========999========')
        let timeVal = ''
        if (/^\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}/.test(obj.enteredValue || obj.defaultContent)) {
          timeVal = (obj.enteredValue || obj.defaultContent)
        }
        vm.setMapData(vm.datetimes,obj.id, timeVal, obj)
      }


    }
  }
}
</script>

<style scoped>
  .verbtn{
    display: block;
    width: 100px;
    margin: 0 auto 20px;

    margin-top: 20px;
  }
  .verifybtn{
    display: inline-block;
    width: 120px;
    height: 36px;
    background:#36c6d3;
    border-radius: 4px;
    color: #ffffff;
    text-align: center;
    line-height: 36px;
    margin-left: 10px;
    cursor: pointer;
  }
  .mat{
    margin-top: 8px;
  }
  .login{
    width: 370px;
    margin: 0 auto;
  }

  .login p{
    margin-top: 20px;
    font-size: 12px;
    color: #999999;
    margin-bottom: 4px;
    margin-left: 64px;
  }
  .login div p{
    color: #ed6b75;
    margin-top: 4px;
    height: 14px;
    line-height: 14px;
  }
  .login div span{
    font-size: 14px;
    color: #666666;
    margin-right: 18px;

  }
  .login div .verifybtn{
      color: #ffffff;
      margin-right: 0;
  }
  .login div .phonenumber{
    width: 300px;
  }
  .login div .verify{
    width: 165px;
  }
  .success{
    width: 500px;
    text-align: center;
    margin-top: 20px;
  }
  .success h4{
    font-size: 16px;
    color: #319bf3;
    margin-top: 14px;
  }
  .success .error{
    color: #ff864a;
  }
  .success p{
    margin-top: 12px;
    color: #999;
  }

  .btn{
    clear: both;
    text-align: center;
    height: 40px;
    width: 100%;
    padding-top: 20px;
    margin-bottom: 20px;
  }
  .btn .color{
    width: 100px;
    height: 40px;
  }
  .content{
    width: 560px;
    position: relative;
    margin:0 auto;
    margin-top: 30px;
    clear: both;
  }
  .content .error1{
    color: #ed6b75;
    position: absolute;
    top: 10px;
    font-size: 12px;
    left: 370px;
    width: 115px;
    line-height: 18px;
  }
 .workerorderindex{
  /*background: #f8f8f8;*/
  width: 100%;
  height: 100%;
 }
 .color{
  background: #009688;
 }
 .top{
   height: 46px;
   width: 100%;
 }
 .logo{
  margin-left: 20px;
  width: 140px;
  height: 34px;
  margin-top: 6px;
 }
 .top img,.top span{
  display: block;
  float: left;
  color: #fff;
  font-size:14px;
  cursor: pointer;
 }
 .top span{
  line-height: 46px;
  margin-left: 10px;
 }
 .kefu{
  margin-left: 370px;
  margin-top: 11px;
 }
 .nav{
  width: 560px;
  margin:0 auto;
  height: 45px;
  border-bottom: 1px solid #000;
  font-size: 14px;
 }
 .nav span{
  line-height: 45px;
  color: #5987c2;
   font-weight:bold;
  text-decoration: underline;
 }
  .nav .btna{
    display: block;
    color: white;
    font-size: 14px;
    width: 70px;
    height: 24px;
    float: right;
    border-radius: 4px;
    text-align:center;
    line-height: 24px;
    margin-top: 11px;
  }
  .nav .navbread{
    text-decoration: none;
    color: #000;
    font-weight:bold;
  }
  .label{
    /*margin-left: 20px;*/
    display: inline-block;
    width: 100px;
    font-size: 14px;
    text-align: right;
    margin-right: 10px;
    display: block;
    float: left;
  }
  .wid{
    width: 250px;
  }
  .dns{
    margin-top:10px;
  }
  .dns .wid{
    margin-left: -5px;
  }
  .explain{
    margin-top:10px;
  }
  .explain   .label{
    display: block;
    float: left
  }

  .sex{
    margin-top: 20px;
  }
  .hobbys{
    margin-top: 20px;
  }
  .hobbys .label{
    display: block;
    float: left;
    margin-top: 4px;
  }
  .hobby{
    margin-left: 10px;
    display: block;
    float: left;
    width: 50px;
    height: 24px;
    border:1px solid #ccc;
    border-radius: 10px;
    background: #fff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    overflow: hidden;
  }
  .back{
    border:1px solid #1f9cf8;
    color: #1f9cf8;
  }
  .hobbys p{
    clear: both;
    font-size: 14px;
    color: #999999;
    margin-left: 140px;
    padding-top: 10px;
  }
  .picture{
    margin-top: 20px;
  }
  .pictureclass{
    font-size: 14px;
    color: #999999;
  }
  .upload-demo{
    margin-left: 140px;
    width: 320px
  }
  .city{
    margin-top: 20px;
  }
  .radio{
    width: 300px;
  }
  .cityclass{
    float: left;
    width: 300px;
  }
  .time{
    width: 300px;
    float: left;
  }
  .date{
    clear: both;
    margin-top: 20px;
  }
  .date .label{
    display: block;
    float: left;
    margin-top: 8px;
  }
  .dns .label{
    display: block;
    float: left;
    margin-top: 6px;
    margin-right: 16px;
  }
  .download{
    width: 640px;
    height: 570px;
    position: fixed;
    background:rgba(0,0,0,0.5);
    color: white;
   left:50%;
   top:50%;
   margin:-264px 0 0 -320px;
   z-index: 1000;
  }
  .download img{
    display: block;
    width: 47px;
    height: 47px;
    margin: 0 auto;
    margin-top: 180px;
  }
  .download  p{
    text-align: center;
    margin-top: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/im/workOrder.vue?330dd14a